<template>
 <div class="admin-detail">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto py-4">
       <div id="header" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">管理者編集</h2>
       </div>
      <div v-if="apiStatus">
        {{statusAlert(true)}}
      </div>
      <div v-show="status" class="validation py-3 px-5 my-4">
          <p class="m-0">{{ status }}</p>
      </div>
       <div class="edit-admin-form mb-4 p-3 mb-2 bg-light text-dark">
         <b-container fluid>
           <b-form v-if="adminData">
              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">氏名</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input class="form-input" v-model="$v.adminData.fullname.$model" placeholder="山田太郎" :state="validateState('fullname')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('fullname')">
                    <p v-if="!$v.adminData.fullname.required">氏名は必須です</p>
                    <p v-if="!$v.adminData.fullname.maxLength">20文字以下で入力してください</p>
                    <p v-if="!$v.adminData.fullname.minLength">氏名{{$v.adminData.fullname.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">ユーザー名</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input class="form-input" v-model="$v.adminData.user_name.$model" placeholder="yamada001" :state="validateState('user_name')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('user_name')">
                    <p v-if="!$v.adminData.user_name.required">ユーザー名は必須です</p>
                    <p v-if="!$v.adminData.user_name.maxLength">20文字以下で入力してください</p>
                    <p v-if="!$v.adminData.user_name.minLength">ユーザー名{{$v.adminData.user_name.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">メールアドレス</label>
                </b-col>
                <b-col lg="10">
                  <b-form-input class="form-input" v-model="$v.adminData.email_address.$model"  autocomplete="nope" placeholder="yamada@globalestate-japan.com/" :state="validateState('email_address')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('email_address')">
                    <p v-if="!$v.adminData.email_address.required">メールアドレスを入力してください</p>
                    <p v-if="!$v.adminData.email_address.email">メールアドレスを正しく入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">パスワード</label>
                </b-col>
                <b-col lg="4">
                  <b-form-input v-model="adminData.password" autocomplete="nope" :type="passwordShowHide" class="form-input"></b-form-input>
                  <span class="field-icon" @click="showPassword = !showPassword">
                    <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPassword">
                    <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
                  </span>
                </b-col>
              </b-row>
              <b-row class="my-3">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">担当エリア</label>
                </b-col>
                <b-col lg="4" class="d-flex align-items-center">
                  <b-form-select v-model="adminData.area_responsibility" class="form-select">
                    <b-form-select-option :value=null disabled>担当エリア</b-form-select-option>
                    <b-form-select-option value="Yokohama">横浜</b-form-select-option>
                    <b-form-select-option value="Sapporo">札幌</b-form-select-option>
                    <b-form-select-option value="HeadQuarters">本部</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>
              <div v-if="permission.data">
              <b-row class="my-3" v-show="permissionControll[0].permission === 'all'">
                <b-col lg="2" class="align-items-center d-flex">
                  <label class="m-0">権限</label>
                </b-col>
                <b-col lg="6" class="align-items-center d-flex">
                  <b-form-group class="m-0 form-radio-button">
                    <b-form-radio-group class="radios" v-model="adminData.role.name">
                      <b-form-radio value="super_authority">スーパー権限</b-form-radio>
                      <b-form-radio value="editorial_rights">編集権限</b-form-radio>
                      <b-form-radio value="posting_permission">投稿権限</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              </div>
           </b-form>
         </b-container>
       </div>
       <div class="d-flex justify-content-between align-items-center">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5" variant="primary" @click="update_admin">更新</b-button></a>
         <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete>削除</b-button>
       </div>
        <b-modal id="modal-delete" ref="modal-delete" class="del-member" size="lg" hide-footer hide-header centered title="BootstrapVue">
          <h6 class="m-4 text-center">本当に削除してもよろしいですか？</h6>
          <div class="d-flex justify-content-center align-items-center">
            <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
            <b-button class="py-3 px-5" variant="danger" @click="delete_admin">削除</b-button>
          </div>
        </b-modal>
     </div>
   </div>
 </div>
</template>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'

export default {
  data () {
    return {
      status: null,
      showPassword: true
    }
  },
  validations: {
    adminData: {
      fullname: {
        required,
        minLength: minLength(0),
        maxLength: maxLength(20)
      },
      user_name: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(20)
      },
      email_address: {
        required,
        email
      }
    }
  },
  created () {
    this.getAdmin(this.$route.params.id)
    this.getPermission()
  },
  computed: {
    ...mapState(['errors', 'apiStatus']),
    ...mapState('adminAccount', ['adminData', 'permission']),
    permissionControll: function () {
      return this.permission.data
        .filter(this.filterBySubject)
    },
    passwordShowHide () {
      return this.showPassword ? 'password' : 'text'
    }
  },
  methods: {
    ...mapActions('adminAccount', ['getAdmin', 'deleteAdmin', 'updateAdmin', 'getPermission']),
    validateState (name) {
      const { $dirty, $error } = this.$v.adminData[name]
      return $dirty ? !$error : null
    },
    validateStates (name) {
      const { $dirty, $error } = this.$v.adminData.role[name]
      return $dirty ? !$error : null
    },
    delete_admin () {
      this.deleteAdmin(this.$route.params.id)
      this.$refs['modal-delete'].hide()
    },
    update_admin () {
      if (this.$v.$invalid) {
        this.status = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        const newAccountInfo = {
          fullname: this.adminData.fullname,
          user_name: this.adminData.user_name,
          email_address: this.adminData.email_address,
          area_responsibility: this.adminData.area_responsibility,
          password: this.adminData.password,
          authority: this.adminData.role.name
        }
        this.updateAdmin(newAccountInfo)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    filterBySubject: function (data) {
      return (data.subject === 'administrator_accounts')
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.apiStatus.Status,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  components: {
    sidebar
  }
}
</script>
